export default "__VITE_ASSET__y$Sjn2kP__"